<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirm()"
  (cancel)="cancel()"
  data-test="create-nitrogen-model-property-dialog"
>
  <div class="flex--container">
    <!-- NutrientDesignation select box -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'nitrogenModelProperties.nutrientDesignation' | translate }}</mat-label>
        <mat-select
          formControlName="nutrientDesignation"
          data-test="create-nitrogen-property-nutrient-designation"
        >
          @for (designation of filteredNutrientDesignations; track designation) {
            <mat-option [value]="designation.designation">
              {{ designation.designation }}
            </mat-option>
          }
        </mat-select>
        @if (formGroup.controls.nutrientDesignation.hasError('required')) {
          <mat-error>
            {{ 'nitrogenModelProperties.nutrientDesignation' | translate }} is required
          </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- SoilType select box -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'nitrogenModelProperties.soilType' | translate }}</mat-label>
        <mat-select formControlName="soilTypeId" data-test="create-nitrogen-property-soil-type">
          @for (soilType of data.soilTypes; track soilType) {
            <mat-option [value]="soilType.id">
              {{ soilType.name }}
            </mat-option>
          }
        </mat-select>
        @if (formGroup.controls.soilTypeId.hasError('required')) {
          <mat-error> {{ 'nitrogenModelProperties.soilType' | translate }} is required </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- SoilTargetUoM select box -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'nitrogenModelProperties.soilTargetUoM' | translate }}</mat-label>
        <mat-select
          formControlName="soilTargetUoM"
          data-test="create-nitrogen-property-soil-target-uom"
        >
          @for (unit of filteredUnitsOfMeasure; track unit) {
            <mat-option [value]="unit.name">
              {{ unit.name }}
            </mat-option>
          }
        </mat-select>
        @if (formGroup.controls.soilTargetUoM.hasError('required')) {
          <mat-error>
            {{ 'nitrogenModelProperties.soilTargetUoM' | translate }} is required
          </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- NBasebuffer input -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'nitrogenModelProperties.nBasebuffer' | translate }}</mat-label>
        <input
          matInput
          formControlName="nBasebuffer"
          agrNumber
          appDecimalSeparator
          step="1"
          data-test="create-nitrogen-property-nBasebuffer"
        />
        @if (
          formGroup.controls.nBasebuffer.hasError('min') ||
          formGroup.controls.nBasebuffer.hasError('max')
        ) {
          <mat-error>
            {{ 'nitrogenModelProperties.nBasebuffer' | translate }} must be between 1 and 99999
          </mat-error>
        }
        @if (formGroup.controls.nBasebuffer.hasError('required')) {
          <mat-error>
            {{ 'nitrogenModelProperties.nBasebuffer' | translate }} is required
          </mat-error>
        }
        @if (formGroup.controls.nBasebuffer.hasError('decimal')) {
          <mat-error>
            {{ formGroup.controls.nBasebuffer.getError('decimal') }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- MaxNbs input -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'nitrogenModelProperties.maxNbs' | translate }}</mat-label>
        <input
          matInput
          formControlName="maxNbs"
          agrNumber
          appDecimalSeparator
          step="1"
          data-test="create-nitrogen-property-maxNbs"
        />
        @if (
          formGroup.controls.maxNbs.hasError('min') || formGroup.controls.maxNbs.hasError('max')
        ) {
          <mat-error>
            {{ 'nitrogenModelProperties.maxNbs' | translate }} must be between 1 and 99999
          </mat-error>
        }
        @if (formGroup.controls.maxNbs.hasError('required')) {
          <mat-error> {{ 'nitrogenModelProperties.maxNbs' | translate }} is required </mat-error>
        }
        @if (formGroup.controls.maxNbs.hasError('decimal')) {
          <mat-error>
            {{ formGroup.controls.maxNbs.getError('decimal') }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- MaxNbsSeedPotato input -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'nitrogenModelProperties.maxNbsSeedPotato' | translate }}</mat-label>
        <input
          matInput
          formControlName="maxNbsSeedPotato"
          agrNumber
          appDecimalSeparator
          step="1"
          data-test="create-nitrogen-property-maxNbsSeedPotato"
        />
        @if (
          formGroup.controls.maxNbsSeedPotato.hasError('min') ||
          formGroup.controls.maxNbsSeedPotato.hasError('max')
        ) {
          <mat-error>
            {{ 'nitrogenModelProperties.maxNbsSeedPotato' | translate }} must be between 1 and 99999
          </mat-error>
        }
        @if (formGroup.controls.maxNbsSeedPotato.hasError('required')) {
          <mat-error>
            {{ 'nitrogenModelProperties.maxNbsSeedPotato' | translate }} is required
          </mat-error>
        }
        @if (formGroup.controls.maxNbsSeedPotato.hasError('decimal')) {
          <mat-error>
            {{ formGroup.controls.maxNbsSeedPotato.getError('decimal') }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</agr-form-dialog>
